import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Gallery } from './pages/Gallery';
import { Financing } from './pages/Financing';
import { Quote } from './pages/Quote';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  useEffect(() => {
    document.title = 'THE EP INC';
  }, []);
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/about" element={<About data-id="element-6" />} data-id="element-5" />
          <Route path="/gallery" element={<Gallery data-id="element-8" />} data-id="element-7" />
          <Route path="/financing" element={<Financing data-id="element-10" />} data-id="element-9" />
          <Route path="/quote" element={<Quote data-id="element-12" />} data-id="element-11" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}